module.exports = __webpack_public_path__ + "static/discover-indie-games-OberionIO-2x-f9b8dd5ded7ed35d29de039ac681e687.png";